import { useInterfaceLanguage } from '@/shared/i18n';
import { SpaceExtraSeatsFeature, SpacesFeature } from '@/shared/types/Settings';
import { UpgradeAlert } from '@/shared/ui/UpgradeAlert';

import { getUpgradeAlertText } from '../lib/getUpgradeAlertText';

export type TeamspaceUpgradeAlertProps = {
  extraSeatsFeature?: SpaceExtraSeatsFeature;
  hasTrialPlan?: boolean;
  spacesFeature: SpacesFeature;
  onClick: () => void;
};

export const TeamspaceUpgradeAlert = ({
  extraSeatsFeature,
  hasTrialPlan,
  spacesFeature,
  onClick,
}: TeamspaceUpgradeAlertProps) => {
  const { t } = useInterfaceLanguage();
  const extraSeats = extraSeatsFeature?.metadata?.quantity || 0;

  let buttonText = t('teamspace.upgrade.addMore');

  if (hasTrialPlan) {
    buttonText = t('teamspace.upgrade.getStarted');
  }

  return (
    <UpgradeAlert
      buttonText={buttonText}
      data-testid="teamspace-upgrade-alert"
      text={getUpgradeAlertText(spacesFeature, t, extraSeats)}
      onClick={onClick}
    />
  );
};
